import { mutationOptions } from '@tanstack/react-query'
import getApiResponseData from '@utils/get-api-response-data'

import { api } from '../api/api'
import { type RequestApi } from '../api/types'
import { key } from './key'

type OfferRequestParams = {
  id: string
  request: RequestApi.OfferRequest
}

export const offerRequestMutation = () =>
  mutationOptions({
    mutationKey: key('offer-request'),
    mutationFn: async ({ id, request }: OfferRequestParams) => {
      const { data } = await api.offer(id, request)
      const offeredRequest = getApiResponseData(data)?.request

      if (!offeredRequest) {
        throw new Error('fulfillment request offer returned no request')
      }

      return offeredRequest
    },
    retry: false,
  })
